import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import CheckIn from "@/pages/CheckIn";
import Privacy from "@/pages/Privacy";
import Pricing from "@/pages/Pricing";
import PaymentResult from "@/pages/PaymentResult";
import Review from "@/pages/Review";
import Report from "@/pages/Report";
import Legal from "@/pages/Legal";
import PrivacyPromise from "@/pages/PrivacyPromise";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Waitlist from "@/pages/Waitlist";
import { OwnerConsole, OwnerVerify, OwnerOnly } from "@/pages/Owner";
import { V2Shell } from "@/v2/V2Shell";
import V2Start from "@/v2/V2Start";
import V2Today from "@/v2/V2Today";
import { JourneyYear, JourneyProgress, JourneyStory } from "@/v2/V2Journey";
import JourneyLayout from "@/v2/JourneyLayout";
import V2Projects from "@/v2/V2Projects";
import V2Weight from "@/v2/V2Weight";
import V2Companion from "@/v2/V2Companion";
import V2Progress from "@/v2/V2Progress";
import V2Me from "@/v2/V2Me";
import V2Recap from "@/v2/V2Recap";

const LEGACY = [["/onboarding", "/start"], ["/v2", "/today"], ["/v2/start", "/start"], ["/v2/recap", "/recap"], ["/v2/journey", "/journey"],
  ["/v2/projects", "/journey/plan"], ["/v2/projects/weight", "/journey/plan/weight"], ["/v2/companion", "/talk"], ["/v2/me", "/you"],
  ["/checkin", "/today/log"], ["/trends", "/journey/progress"], ["/companion", "/talk"], ["/me", "/you"], ["/me/habits", "/journey/plan"],
  ["/me/reflections", "/journey/story"], ["/me/privacy", "/you/privacy"], ["/me/report", "/you/report"]];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/review" element={<Protected><OwnerOnly><Review /></OwnerOnly></Protected>} />
          <Route path="/legal/:doc" element={<Legal />} />
          <Route path="/privacy-promise" element={<PrivacyPromise />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/owner/verify" element={<Protected><OwnerVerify /></Protected>} />
          <Route path="/you/owner" element={<Protected><OwnerConsole /></Protected>} />
          <Route path="/payment/success" element={<Protected><PaymentResult success /></Protected>} />
          <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
          <Route path="/you/report" element={<Protected><Report /></Protected>} />
          <Route path="/start" element={<Protected allowUnboarded><V2Start /></Protected>} />
          <Route path="/recap" element={<Protected><V2Recap /></Protected>} />
          <Route element={<Protected><V2Shell /></Protected>}>
            <Route path="/today" element={<V2Today />} />
            <Route path="/today/log" element={<CheckIn />} />
            <Route path="/journey" element={<JourneyLayout />}>
              <Route index element={<JourneyYear />} />
              <Route path="progress" element={<JourneyProgress />} />
              <Route path="plan" element={<V2Projects />} />
              <Route path="plan/weight" element={<V2Weight />} />
              <Route path="story" element={<JourneyStory />} />
            </Route>
            <Route path="/progress" element={<V2Progress />} />
            <Route path="/talk" element={<V2Companion />} />
            <Route path="/you" element={<V2Me />} />
            <Route path="/you/privacy" element={<Privacy />} />
          </Route>
          {LEGACY.map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
